import normalizePathname from './normalizePathname';

const isSubUrlOf = (url: string, maybeSubUrl: string) => {
  const cleanUrl = normalizePathname(url || '');
  const cleanSubUrl = normalizePathname(maybeSubUrl || '');
  return cleanUrl.indexOf(cleanSubUrl) > -1;
};

export default isSubUrlOf;
